<template>
    <div class="section-box people">
        <el-tabs v-model="tap" type="card" class="customer-tabs-mg" :before-leave="tabSelect">
            <el-tab-pane v-for="(item, index) in tapArr" :label="item.value" :name="item.key + ''"
                :key="index"></el-tab-pane>
        </el-tabs>


        <el-form ref="searchForm" inline label-width="120px">
            <el-form-item label="跳转到日期：">
                <el-date-picker v-model="searchTime" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="confirmDate">确认</el-button>
            </el-form-item>
        </el-form>
        <div class="calendar-box">
            <el-calendar v-model="selectDate" ref="elCalendarRef">
                <template slot="dateCell" slot-scope="{date, data}">
                    <!-- <div class="day-cell">
                        <span> {{ data.day.split('-').slice(1).join('-') }}
                            <span class="orange">{{ '[' + getDateTypeName(data.day) + ']' }}</span>
                        </span>
                        <span class="tag" v-if="getDutyManageUser(data.day,1)">
                            {{ getDutyManageUser(data.day,2) }} <i class="el-icon-close"
                                @click="removeManageUser(data.day)"></i>
                        </span>

                        <el-dropdown v-if="!getDutyManageUser(data.day,3) && data.isSelected" @command="setManageUser"
                            class="dropdown">
                            <span class="el-dropdown-link">
                                {{ getDateType(data.day) == 0 ? '设置晚间值班' : '设置节假日全天值班' }}
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="item.UserId" v-for="(item, index) in djrArr" v-bind="item"
                                    :key="index">{{ item.RealName }}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div> -->
                    <duty-day v-if="djrArr && dayList" :day="data.day" :djrArr="djrArr" :dayList="dayList"
                        :dytyList="dytyList" :isSelected="data.isSelected" @setManageUser="setManageUser"
                        @removeManageUser="removeManageUser"></duty-day>
                </template>
            </el-calendar>
        </div>
    </div>
</template>

<script>
import {
    getTakeOverUserList,    //获取负责人
    getDistributeJobHolidayDayList,
    addDistributeJobHolidayDay,
    removeDistributeJobHolidayDay
} from "@/service/job";
import {
    GetDayProperty
} from "@/service/sys";
import dutyDay from "./dutyDay.vue";
export default {
    components: {
        dutyDay
    },
    data() {
        return {
            tapArr: [{
                key: 1,
                value: "派单管理",
            }, {
                key: 2,
                value: "值班人员配置",
            }],
            tap: '2',

            searchTime: "",
            djrArr: [],  //对接人列表
            elCalendar: null,
            selectDate: new Date(),
            dayList: [],//日期属性列表
            dytyList: [],//值班列表
            // dayTypeLabel: {
            //     0: "工作日",
            //     1: "3倍节假日",
            //     2: "按工作日价格",
            //     3: "按周末价格",
            //     4: "普通节假日",
            //     5: "周末"
            // }
            nummm: 0
        }
    },
    mounted() {
        this.elCalendar = this.$refs.elCalendarRef;
    },
    created() {
        this.getTakeOverUserListFun();
    },
    watch: {
        selectDate(newval, oldval) {
            console.log("newval:" + JSON.stringify(newval));

            console.log("oldval" + JSON.stringify(oldval));
            // var date_pro = this.getDayProperty('2025-09-01');
        },
        'elCalendar.curMonthDatePrefix': { //监听月份的变化
            handler(newval, oldval) {
                var date = newval + '-01';
                //console.log("oldval2222", newval, oldval);
                this.getMonthDay(date);
                this.getDistributeJobHolidayDayList(date)
            },
        }
    },
    methods: {
        //切换tab之前
        tabSelect(activeName, oldActiveName) {
            console.log('activeName:' + activeName + ";oldActiveName:" + oldActiveName);
            if (activeName == "1") {
                this.$router.push('/distributeJob/distributeJobConfig');
                return false;
            }
            else {
                return true;
            }
        },
        confirmDate() {
            console.log("searchTime:" + this.searchTime)
            if (!this.searchTime) {

                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth() + 1;
                var day = now.getDate();
                var str = year + '-' + month + "-" + day;
                console.log("str:" + str)
                var today = new Date(str);
                console.log("now:" + now)
 
                this.selectDate = today;
            }
            else {
                this.selectDate = new Date(this.searchTime);
            }
        },
        //获取某个月份的日期属性
        getMonthDay(date) {
            GetDayProperty({ Date: date }).then((res) => {
                if (res.Result == 0) {
                    return this.$message.warning(res.Message);
                }
                if (res.Data) {
                    this.dayList = res.Data;
                }
                console.log("dayList:" + JSON.stringify(this.dayList))
            })
        },
        //获取某个月份的值班数据
        getDistributeJobHolidayDayList(date) {
            getDistributeJobHolidayDayList({ Date: date }).then((res) => {
                if (res.Result == 0) {
                    return this.$message.warning(res.Message);
                }
                if (res.Data) {
                    this.dytyList = res.Data;
                }
                console.log("dytyList:" + JSON.stringify(this.dytyList))
            })
        },

        // 获取对接人
        getTakeOverUserListFun() {
            getTakeOverUserList().then(res => {
                if (res.Result == 0) {
                    return this.$message.warning(res.Message);
                }
                if (res.Data) {
                    this.djrArr = res.Data;
                }
            })
        },

        setManageUser(userId) {
            console.log("setManageUser selectDate:" + this.selectDate);
            if (this.selectDate) {
                var str = JSON.stringify(this.selectDate);
                var date = str.substring(1, 11);
                console.log("selectDate:" + date);

                var user = this.djrArr.find(f => f.UserId == userId);
                console.log("user:" + JSON.stringify(user));

                if (!user) {
                    return this.$message.warning('未找到对应的值班人员');
                }

                addDistributeJobHolidayDay({
                    Date: date,
                    ServiceManageUserId: userId,
                    ServiceManageUserName: user.RealName
                }).then((res) => {
                    if (res.Result == 0) {
                        return this.$message.warning(res.Message);
                    }

                    this.dytyList.push({
                        Date: date,
                        ManageUserId: userId,
                        ManageUserName: user.RealName
                    });

                    return this.$message.success(res.Message);
                });
            }
        },
        removeManageUser(date) {
            console.log("removeManageUser date:" + date);
            if (date) {
                console.log("date:" + date);

                removeDistributeJobHolidayDay({
                    Date: date
                }).then((res) => {
                    if (res.Result == 0) {
                        return this.$message.warning(res.Message);
                    }

                    for (var i = 0; i < this.dytyList.length; i++) {
                        if (this.dytyList[i].Date == date) {
                            this.dytyList.splice(i, 1);
                            break;
                        }
                    }

                    return this.$message.success(res.Message);
                });
            }
        }


    }
}
</script>


<style scoped lang="scss">
.section-box {
    .calendar-box {
        padding: 10px;
        border: 1px solid rgb(220, 223, 230);
    }
}
</style>